module.exports = __webpack_public_path__ + "static/media/handtherapie.de2f0138.jpg";